import React, { FC, ReactNode } from 'react';
import Box from '@material-ui/core/Box';

import { MicrodataScheme } from '@keaze/web/common/interfaces';
import {
  Accordion as UIAccordion,
  AccordionDetails,
  AccordionSummary,
  ExpandMoreIcon,
  Group,
} from './accordion.styles';
import {
  AccordionProps,
  AccordionData,
  AccordionSize,
} from './accordion.types';

type RenderAccordion = (
  accordion: AccordionData,
  size: AccordionSize,
  microdataScheme: MicrodataScheme
) => JSX.Element;

// todo Tanya: change type for event
type ScrollSmoothTo = (e: any) => void;

type GeneratedAnchorPropsExpected = {
  id: string;
  onClick: ScrollSmoothTo;
};

type GeneratedAnchorProps = (
  id?: string
) => GeneratedAnchorPropsExpected | undefined;

type RenderDescription = (
  description: ReactNode,
  microdataScheme: MicrodataScheme
) => ReactNode;

const scrollSmoothTo: ScrollSmoothTo = (e) =>
  setTimeout(() => {
    e.target.parentNode.scrollIntoView({ behavior: 'smooth' });
  }, 200);

const generatedAnchorProps: GeneratedAnchorProps = (id) => {
  if (id) {
    return {
      id,
      onClick: scrollSmoothTo,
    };
  }

  return undefined;
};

const renderDescription: RenderDescription = (description, microdataScheme) => (
  <div {...microdataScheme['descriptionValue']}>
    {Array.isArray(description)
      ? description.map((value, key) => <Group key={key}>{value}</Group>)
      : description}
  </div>
);

const renderAccordion: RenderAccordion = (
  { name, description, id },
  size,
  microdataScheme
) => {
  const ariaControls = `${name}-content`;

  return (
    <UIAccordion key={name} {...microdataScheme['entity']}>
      <AccordionSummary
        {...generatedAnchorProps(id)}
        $size={size}
        expandIcon={<ExpandMoreIcon />}
        aria-controls={ariaControls}
      >
        <span {...microdataScheme['entityTitle']}>{name}</span>
      </AccordionSummary>
      <AccordionDetails>
        <div {...microdataScheme['description']}>
          {renderDescription(description, microdataScheme)}
        </div>
      </AccordionDetails>
    </UIAccordion>
  );
};

export const Accordion: FC<AccordionProps> = ({
  data,
  size = AccordionSize.Small,
  microdataScheme = {},
}) => (
  <Box {...microdataScheme['wrapper']}>
    {data.map((accordion) => renderAccordion(accordion, size, microdataScheme))}
  </Box>
);
